import localFont from 'next/font/local';

/**
 * Load fonts
 */
const lamaSansStandard = localFont({
  src: [
    {
      path: './LamaSans-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: './LamaSans-Medium.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: './LamaSans-ExtraBold.woff2',
      weight: '800',
      style: 'normal',
    },
  ],
  display: 'swap',
});
const lamaSansBlack = localFont({
  src: './LamaSans-Black.woff2',
  weight: '900',
  display: 'swap',
});
const lamaSansBlackCondensed = localFont({
  src: './LamaSans-BlackCondensed.woff2',
  weight: '900',
  display: 'swap',
});
const lamaSansExtraBoldCondensed = localFont({
  src: './LamaSans-ExtraBoldCondensed.woff2',
  weight: '800',
  display: 'swap',
});

/**
 * Setup theme fonts
 */
export const UIKitThemeConfigFonts = {
  ltr: {
    fontSize: 16,
    h1: lamaSansBlackCondensed.style.fontFamily,
    h2: lamaSansBlackCondensed.style.fontFamily,
    h3: lamaSansBlackCondensed.style.fontFamily,
    h4: lamaSansBlackCondensed.style.fontFamily,
    h5: lamaSansBlackCondensed.style.fontFamily,
    h6: lamaSansBlackCondensed.style.fontFamily,
    h7: lamaSansBlackCondensed.style.fontFamily,
    largeParagraph: lamaSansStandard.style.fontFamily,
    body1: lamaSansStandard.style.fontFamily,
    body2: lamaSansStandard.style.fontFamily,
    small: lamaSansStandard.style.fontFamily,
    smallParagraph: lamaSansStandard.style.fontFamily,
    overline: lamaSansExtraBoldCondensed.style.fontFamily,
    button: lamaSansStandard.style.fontFamily,
    extraSmall: lamaSansStandard.style.fontFamily,
    smallOverline: lamaSansExtraBoldCondensed.style.fontFamily,
  },
  rtl: {
    fontSize: 16,
    h1: lamaSansBlack.style.fontFamily,
    h2: lamaSansBlack.style.fontFamily,
    h3: lamaSansBlack.style.fontFamily,
    h4: lamaSansBlack.style.fontFamily,
    h5: lamaSansBlack.style.fontFamily,
    h6: lamaSansBlack.style.fontFamily,
    h7: lamaSansBlack.style.fontFamily,
    largeParagraph: lamaSansBlackCondensed.style.fontFamily,
    body1: lamaSansStandard.style.fontFamily,
    body2: lamaSansStandard.style.fontFamily,
    small: lamaSansStandard.style.fontFamily,
    smallParagraph: lamaSansStandard.style.fontFamily,
    overline: lamaSansStandard.style.fontFamily,
    button: lamaSansStandard.style.fontFamily,
    extraSmall: lamaSansStandard.style.fontFamily,
    smallOverline: lamaSansStandard.style.fontFamily,
  },
};
